// extracted by mini-css-extract-plugin
export default {"customerPages":"LoggedUserRoutes_customerPages__g9VtZ"};